<!--
 * @Description: 我的网络课程 添加
 * @Author: PF
 * @Date: 2023-10-08 10:29:32
 * @LastEditors: PF
 * @LastEditTime: 2025-11-13 10:40:57
-->
<template>
  <div>
    <el-dialog class="wp70 hp80" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <el-container>
        <el-header>
        <el-steps :active="stepActive" align-center finish-status="success" class="mb10 pl10 pt10 pr10 pm10">
          <el-step title="基本信息" @click="buZhouTiao(0)" />
          <el-step title="目录及资源" @click="buZhouTiao(1)" />
          <el-step title="相关网络课程" @click="buZhouTiao(2)" />
        </el-steps>

        </el-header>
        <el-main>

          <el-form v-if="stepActive===0" ref="ruleFormRef" :model="ruleForm" label-width="106px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="网络课程名称" prop="wlkcmc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <el-input v-model="ruleForm.wlkcmc" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关键字" prop="gjz" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <el-input v-model="ruleForm.gjz" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="课程" prop="wljxkcid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <!-- 单选 BEGIN -->
                  <div class="an-niu wp100" style="display: flex; align-items: center;">
                    <el-button type="primary" class="w100" @click="openKeChengDanTiao=true">选择</el-button>
                    <el-button class="ml10 mr10" link v-if="ruleForm.wljxkcmc" @click="ruleForm.wljxkcmc='';ruleForm.wljxkcid=''">清空</el-button>
                    <el-tag v-if="ruleForm.wljxkcmc" :disable-transitions="false">
                      {{ ruleForm.wljxkcmc }}
                    </el-tag>
                  </div>
                  <!-- 单选 END -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="教材" prop="jcid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <!-- 单选 BEGIN -->
                  <div class="an-niu wp100" style="display: flex; align-items: center;">
                    <el-button type="primary" class="w100" @click="openJiaoCaiDanTiao=true">选择</el-button>
                    <el-button class="ml10 mr10" link v-if="ruleForm.jcmc" @click="ruleForm.jcmc='';ruleForm.jcid='';ruleForm.listZiYuan=[];ruleForm.listMuLuZiYuan=[]">清空</el-button>
                    <el-tag v-if="ruleForm.jcmc" :disable-transitions="false">
                      {{ ruleForm.jcmc }}
                    </el-tag>
                  </div>
                  <!-- 单选 END -->
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="封面图">
                  <el-upload class="suoluetu" :auto-upload="true" :show-file-list="false" accept=".jpg,.jpeg,.png," upFolder="cyrcglCpgl" action="#" :http-request="fmtClick">
                    <tupian :img="ruleForm.fmt" :wid="'150px'" :hei="'100px'" :fit="'cover'"/>
                  </el-upload>
                  <span style="margin-left: 5px;">封面图尺寸 600*400</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="课程简介" prop="kcjj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <el-input v-model="ruleForm.kcjj" :autosize="{ minRows: 6 }" type="textarea" resize="none" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          
          <el-form v-if="stepActive===1" ref="ruleFormRef" :model="ruleForm" label-width="90px">
            <div style="height: calc(100% - 30px);overflow: auto;margin-top: 10px;" v-loading="treeLoading">
              <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">网络课程名称：{{ ruleForm.wlkcmc }}</div>
              <div v-for="(item, index) in ruleForm.listMuLuZiYuan" :key="index">
                <span style="height: 26px;line-height: 26px;">{{item.name}}</span>
                <div class="custom-tree-node" v-for="(val, ind) in item.children" :key="ind">
                  <span>{{ val.name }}</span>
                  <div>
                    <span v-if="val.zyid">资源名称：{{ val.zymc }}</span>
                    <el-text v-if="val.zyid" class="ml20 pointer" type="danger" @click="dqwz={index, val, ind};yiChuZiYuan()">移除资源</el-text>
                    <el-text v-if="!val.zyid" class="ml20 pointer" type="primary" @click="dqwz={index, val, ind}; openZiYuanDanTiao=true">指定资源</el-text>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
          
          <el-form v-if="stepActive===2" ref="ruleFormRef" :model="ruleForm" label-width="60px" style="height: 100%;">
            <el-transfer v-model="ruleForm.listXgwlkcid" :data="dataGrid.data" :props="{ key: 'id', label: 'wlkcmc' }" filterable filter-placeholder="请输入..." />
          </el-form>

        </el-main>
      </el-container>

      <template #footer>
        <div class="dialog-footer">
          <div style="line-height: 53px;">
            <pagination v-if="stepActive==2" :pagination="dataGrid.pagination" @ReturnData="initLeftList" />
          </div>
          <div class="footer_but">
            <el-button v-if="stepActive>0" type="primary" @click="buZhouTiao(stepActive-1)">上一步</el-button>
            <el-button v-if="stepActive<2" type="primary" @click="buZhouTiao(stepActive+1)">下一步</el-button>
            <el-button type="primary" @click="submit()">保存</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <wangluokecheng v-if="openKeChengDanTiao" v-model:openDanTiao="openKeChengDanTiao" :row="row" @ReturnData="ReturnDataKeCheng" />
  <jiaocaidantiao v-if="openJiaoCaiDanTiao" v-model:openDanTiao="openJiaoCaiDanTiao" :row="row" @ReturnData="ReturnDataJiaoCai" />
  <ziyuandantiao v-if="openZiYuanDanTiao" v-model:openDanTiao="openZiYuanDanTiao" @ReturnData="ReturnZiYuanData" />
</template>

<script setup>
import { defineEmits, ref, defineProps, unref, watch } from 'vue'
import { closeWindow, loadSelect, actionPost, loadList } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import { uploadV2 } from '@/api/publicApi'
import wangluokecheng from '@/components/chazhaodaihui/wangluokechengdantiao.vue'
import jiaocaidantiao from '@/components/chazhaodaihui/jiaocaidantiao.vue'
import tupian from "@/components/tupian.vue";
import pagination from '@/components/pagination.vue'
import ziyuandantiao from './ziyuandantiao'

const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])

const stepActive = ref(0)
const row = ref()

const ruleFormRef = ref(null)
const ruleForm = ref({ listZiYuan: [], listMuLuZiYuan: [], listXgwlkcid: [] })

const buZhouTiao = async (val) => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  stepActive.value = val
}

// 选择课程
const openKeChengDanTiao = ref(false)
const ReturnDataKeCheng = (data) => {
  ruleForm.value.wljxkcid = data.id
  ruleForm.value.wljxkcmc = data.mc
}
// 选择教材
const openJiaoCaiDanTiao = ref(false)
const ReturnDataJiaoCai = (data) => {
  if (ruleForm.value.jcid !== data.id) {
    ruleForm.value.listZiYuan = []
    ruleForm.value.listMuLuZiYuan = []
  }
  ruleForm.value.jcid = data.id
  ruleForm.value.jcmc = data.jcmc
  bindTree()
}

// 封面图上传
const fmtClick = async (file) => {
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'wdwlkcfmt')
  uploadV2(formData).then((res) => {
    ruleForm.value.fmt = res.data.lj + res.data.mc
  })
}

// 教材目录 BEGIN
const treeLoading = ref(false)
const bindTree = async () => {
  treeLoading.value = true
  actionPost({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/jiaocaimulushu',
    data: { jcid: ruleForm.value.jcid }
  }).then((res) => {
    treeLoading.value = false
    if (res.code === 200) {
      ruleForm.value.listMuLuZiYuan = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
// 资源 单选 BEGIN
const dqwz = ref()
const openZiYuanDanTiao = ref(false)
const ReturnZiYuanData = (data) => {
  ruleForm.value.listMuLuZiYuan[dqwz.value.index].children[dqwz.value.ind].zyid = data.id
  ruleForm.value.listMuLuZiYuan[dqwz.value.index].children[dqwz.value.ind].zymc = data.zymc
}
const yiChuZiYuan = () => {
  ruleForm.value.listMuLuZiYuan[dqwz.value.index].children[dqwz.value.ind].zyid = ''
  ruleForm.value.listMuLuZiYuan[dqwz.value.index].children[dqwz.value.ind].zymc = ''
}
// 资源 单选 END

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'wlkcmc', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    initLeftList()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const initLeftList = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/wangluojiaoxue/wangluokecheng/gongxiangpagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      initLeftList()
    }
  },
  { deep: true, immediate: true }
)
// 提交
const submit = async () => {
  ruleForm.value.menuId = sessionStorage.getItem('menuId')
  actionPost({
    url: '/api/v2/wangluojiaoxue/wangluokecheng',
    data: ruleForm.value
  }).then((res) => {
    if (res.code === 200) {
      closeWindow('openAdd', emits, true)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>

<style lang="less" scoped>
.suoluetu {
  border: 1px dashed #dcdfe6;
	width: 150px;
	height: 100px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  :deep(.el-upload) {
    width: 100%;
    height: 100%;
  }
  i {
    font-size: 1.5rem;
  }
}
:deep(.el-tree-node__content) {
  width: 100%;
}
:deep(.el-tree-node__label) {
  width: 100%;
}
.custom-tree-node {
  width: 100%;
  height: 26px;
  line-height: 26px;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
}
.custom-tree-node:hover {
  background-color: #ecf5ff;
}

:deep(.el-transfer) {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
:deep(.el-transfer-panel) {
  width: 50%;
  height: 100%;
}
:deep(.el-transfer-panel__body) {
  height: calc(100% - 40px);
}
:deep(.el-transfer__buttons) {
  display: flex;
  flex-direction: column-reverse;
  padding: 10px;
}
:deep(.el-transfer__button:nth-child(2)) {
  margin: 0 0 10px 0;
}
:deep(.el-checkbox__label) {
  width: 100%;
}

</style>
